import React, { useEffect, useState } from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useTranslation } from 'react-i18next';
import { parseError } from '../../../services/utils';
import { useFormContext, useWatch } from 'react-hook-form';
import FormField from '../../common/form-field';
import { SelectController } from './select';
import { useService } from '../../../services/services';
import { map } from 'rxjs/operators';
import { TextInputComponent } from './text';

export default function Address(
  name: string,
  label: string,
  column?: boolean,
  creatable?: boolean,
  horizontal?: boolean
): FormComponent {
  return ({ ...rest }) => (
    <AddressComponent
      name={name}
      label={label}
      column={column}
      creatable={creatable}
      horizontal={horizontal}
      {...rest}
    />
  );
}

export function AddressComponent({
  name,
  label,
  column,
  creatable,
  disabled,
  required,
  horizontal = false,
}: FormComponentProps & {
  name: string;
  label: string;
  column?: boolean;
  creatable: boolean;
  horizontal?: boolean;
}) {
  const { t } = useTranslation();
  const {
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const error = parseError(name, errors);
  const { vzdService } = useService();

  const [vzdServiceAvailable, setVzdServiceAvailable] = useState(true);

  const value = useWatch({ name });

  useEffect(() => {
    if (vzdServiceAvailable === false) {
      let valueAsString = getValues(name);
      if (typeof value === 'object') {
        valueAsString = value?.value;
      }

      setValue(name, valueAsString ?? '');
    }
  }, [vzdServiceAvailable, setValue, getValues, name, value]);

  const asyncOptions = (value: string) => {
    return vzdService.searchAddress(value).pipe(
      map((response: any) => {
        if (response === null) {
          setVzdServiceAvailable(false);
          return {
            hasMore: false,
            options: [],
            additional: {},
          };
        }

        return {
          hasMore: false,
          options: response.map((obj: any) => ({
            label: obj.address + (obj.zipCode ? ' ' + obj.zipCode : ''),
            value: obj.address + (obj.zipCode ? ' ' + obj.zipCode : ''),
          })),
          additional: {},
        };
      })
    );
  };

  return (
    <FormField
      label={t(label)}
      column={column}
      creatable={creatable}
      labelFor={name}
      required={required?.includes(name)}
      error={error?.message ?? null}
      horizontal={horizontal}
    >
      {vzdServiceAvailable ? (
        <SelectController
          multi={false}
          disabled={disabled}
          asyncOptions={asyncOptions}
          options={[]}
          cacheOn={[]}
          name={name}
          parentName={null}
          clearable={true}
          creatable={creatable}
        />
      ) : (
        <TextInputComponent
          name={name}
          readonly={disabled}
          disabled={disabled}
          icon={null}
        />
      )}
    </FormField>
  );
}
